<script lang="ts">
	import { SvgWrapper } from '../../../storybook-util/icons/components/SvgWrapper';
	import { getTailwindColor } from '../../../storybook-util/icons/utils/getTailwindColor/getTailwindColor';
	interface Props {
		color?: string | undefined;
		title?: string | undefined;
		class?: string;
		'data-cy'?: string;
	}

	let { color = 'gray-900', title = undefined, ...rest }: Props = $props();
</script>

<SvgWrapper {title} {...rest}>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M21.2308 7.64706C21.2308 6.18513 20.1037 5 18.7133 5H5.28677C3.8964 5 2.76929 6.18513 2.76929 7.64706V17.3529C2.76929 18.8149 3.8964 20 5.28677 20H18.7133C20.1037 20 21.2308 18.8149 21.2308 17.3529V7.64706ZM19.2838 6.29306C19.1059 6.20286 18.911 6.15385 18.7133 6.15385H5.28677C5.03049 6.15385 4.77889 6.23623 4.56297 6.38393L10.5641 12.694C11.2592 13.4248 12.3619 13.2718 12.9114 12.694L12.9206 12.6845L19.2838 6.29306ZM3.92313 7.64706C3.92313 7.56282 3.92922 7.48103 3.94085 7.40199L9.76894 13.5301C10.9696 14.7925 12.7833 14.4952 13.7017 13.5352L20.0145 7.19433C20.0549 7.33497 20.077 7.48658 20.077 7.64706V17.3529C20.077 18.2329 19.4126 18.8462 18.7133 18.8462H5.28677C4.58754 18.8462 3.92313 18.2329 3.92313 17.3529V7.64706Z"
		fill={getTailwindColor(color)}
	/>
</SvgWrapper>
